
// identifiers
const contentID = '_gs_bundle_contents'
const senderID = 'remitente'
const receiverID = 'destinatario'
const messageID = 'contenido'
const boxID = 'Caja'

// formatContent function split the lines of text that comes in bundleInformation.contenido to be text more readable 
const formatContent = (string) => {
  const isNumberRegExp = /\d/
  const items = string.split(' : ')

  let lastAmountItemLength = 0

  const result = items.reduce((acc, item, index, array) => {
    const nextItem = array[index + 1]
    if (! nextItem) return acc;

    const chars = nextItem.split('')
    let amount = ''

    for (let i = 0; i < chars.length; i++) {
      const char = chars[i]
      const isNumber = isNumberRegExp.test(char)

      if (! isNumber) break;
      amount += char
    }

    const newItem = (index > 0)
      ? item.substring(lastAmountItemLength, item.length)
      : item

    lastAmountItemLength = amount.length
    return acc + `${newItem} : ${amount} pieza(s) \n`
  }, '')

  return result
}

const loadBoxChoisBundleInfo = (selector, id) => {
  const $container = document.querySelector(selector)
  const $values = document.querySelectorAll(`.values-properties-box-${id}`)

  const bundleInformation = {}

  const values = []
  
  $values.forEach($value => values.push($value.innerText))

  const contentIndex = values.findIndex((value) => value.startsWith(contentID))
  const senderIndex = values.findIndex((value) => value.startsWith(senderID))
  const receiverIndex = values.findIndex((value) => value.startsWith(receiverID))
  const messageIndex = values.findIndex((value) => value.startsWith(messageID))
  const boxIndex = values.findIndex((value) => value.startsWith(boxID))

  if (contentIndex !== -1) {
    bundleInformation.contenido = values[contentIndex].split(contentID)[1]
  }

  if (senderIndex !== -1) {
    bundleInformation.remitente = values[senderIndex].split(senderID)[1]
  }

  if (receiverIndex !== -1) {
    bundleInformation.destinatario = values[receiverIndex].split(receiverID)[1]
  }

  if (messageIndex !== -1) {
    bundleInformation.mensaje = values[messageIndex].split(messageID)[1]
  }

  if (boxIndex !== -1) {
    bundleInformation.caja = values[boxIndex].split(boxID)[1]
  }

  if (bundleInformation.contenido) {
    bundleInformation.contenido = bundleInformation
      .contenido
      .replaceAll('- Default Title -', '')
      .replaceAll(' Cantidad: ', ': ')

    bundleInformation.contenido = formatContent(bundleInformation.contenido)
  }

  const entries = Object.entries(bundleInformation);

  entries.reverse().forEach(([key, value], index) => {
    if (value.trim() === '') return

    const $p = document.createElement('p')
    const $key = document.createElement('span')
    const $value = document.createElement('span')

    $p.classList.add('flex', 'flex-col')

    $key.textContent = `${key}:`
    $value.textContent = `${value}`

    $key.classList.add('font-bold', 'uppercase');
    if ($value.textContent.includes('\n')) {
      $value.classList.add('whitespace-pre')
    }

    // insert on HTML
    $p.append($key, $value)
    $container.append($p);
  })

  return bundleInformation
}

// this function set the information parsed in the Order
const setCartAttributesOnCheckout = (bundleInformation, id) => {

  if (bundleInformation.contenido) {
    const $contentInput = document.querySelector(`#paquete-${id}-contenido`)
    if ($contentInput) {
      $contentInput.setAttribute("value", bundleInformation.contenido)
    }
  }

  if (bundleInformation.caja) {
    const $cajaInput = document.querySelector(`#paquete-${id}-caja`)
    if ($cajaInput) {
      $cajaInput.setAttribute("value", bundleInformation.caja)
    }
  }

  if (bundleInformation.destinatario) {
    const $destinatarioInput = document.querySelector(`#paquete-${id}-destinatario`)
    if ($destinatarioInput) {
      $destinatarioInput.setAttribute("value", bundleInformation.destinatario)
    }
  }

  if (bundleInformation.remitente) {
    const $remitenteInput = document.querySelector(`#paquete-${id}-remitente`)
    if ($remitenteInput) {
      $remitenteInput.setAttribute("value", bundleInformation.remitente)
    }
  }

  if (bundleInformation.mensaje) {
    const $mensajeInput = document.querySelector(`#paquete-${id}-mensaje`)
    if ($mensajeInput) {
      $mensajeInput.setAttribute("value", bundleInformation.mensaje)
    }
  }

  if (!(bundleInformation.mensaje) || !(bundleInformation.remitente) || !(bundleInformation.destinatario)) {
    const $notasInput = document.querySelector(`#paquete-${id}-notas`)
    if ($notasInput) {
      $notasInput.setAttribute("value", 'La tarjeta debe de ir sin información')
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const $infoBundlesContainers = document.querySelectorAll('[id^="bundle-info"')

  if( $infoBundlesContainers.length === 0 ) {
    console.info('No se han pedidos de box arma tu BoxChois')
    return
  }

  $infoBundlesContainers.forEach(($_container, index) => {
    const selector = `#bundle-info-${index+1}`
    const bundleInformation = loadBoxChoisBundleInfo(selector, index+1)
    console.log({bundleInformation})
    // this set the cart attributes on the form elements to be sent in the order
    setCartAttributesOnCheckout(bundleInformation, index+1)
  })
});
